import { ForegroundLayer } from './components/ForegroundLayer'
import { BackgroundLayer } from './components/BackgroundLayer'
import { ScreenContainer } from './components/ScreenContainer'
import { VisitError } from './components/VisitError'
import { RemoteAudio } from './components/RemoteAudio'

export function DailyVisit() {
  return (
    <div className='tailwind-scoped' style={{ position: 'relative', width: '100%', flex: 1 }}>
      <VisitError />
      <ScreenContainer>
        <ForegroundLayer />
        <BackgroundLayer />
      </ScreenContainer>
      <RemoteAudio />
    </div>
  )
}
